<template>
  <div class="box-body">
    <div>
      <lte-button
        style="float:right"
        type="btn btn-primary"
        v-if="GET_ACCOUNT_DATA.group_id == 1 || has_perm('create_case')"
        right_icon="fa fa-plus"
        @click="addNew($event)"
        >{{ $t("invoice.addnew") }}</lte-button
      >
    </div>
    <div>
      <b-table outlined :items="departmentItems" :fields="DepartmentFields">
        <template #head()="scope">
          <div class="">{{ $t(scope.label) }}</div>
        </template>
        <template #cell(actions)="row">
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-danger dropdown-toggle"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i class="fa fa-fw fa-ellipsis-h"></i>
            </button>
            <ul class="dropdown-menu" style="min-width: 50px;">
              <li>
                <button
                  v-if="
                    GET_ACCOUNT_DATA.group_id == 1 || has_perm('update_case')
                  "
                  class="btn btn-primary btn-sm"
                  style="margin-left: 6px;"
                  @click="onShowDetail(row.item)"
                >
                  <i class="glyphicon glyphicon-edit"></i>
                </button>
              </li>
              <li style="margin-top: 5px">
                <button
                  v-if="GET_ACCOUNT_DATA.id == 1"
                  class="btn btn-info btn-sm"
                  style="margin-left: 6px;"
                  @click="onShowUserInDepartment(row.item)"
                >
                  <i class="glyphicon glyphicon-user"></i>
                </button>
              </li>
              <li style="margin-top: 5px">
                <button
                  v-if="
                    GET_ACCOUNT_DATA.group_id == 1 || has_perm('delete_case')
                  "
                  class="btn btn-danger btn-sm"
                  style="margin-left: 6px;"
                  @click="onDeleteDepartment(row)"
                >
                  <i class="glyphicon glyphicon-trash"></i>
                </button>
              </li>
            </ul>
          </div>
        </template>
      </b-table>
      <div class="box-footer clearfix" style="display:contents;">
        <custom-paginator
          :totalItem="paginateData.totalItem"
          :currentPage="paginateData.currentPage"
          :pageSize="paginateData.pageSize"
          :totalPage="paginateData.totalPage"
          @onpaginate="onCustomPagination"
        />
      </div>
      <!--  -->
    </div>
    <!-- Modal modal-department -->
    <div
      class="modal fade"
      :ref="`modal-department`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{
                $t(
                  departmentData.id === 0
                    ? "feedback.config.addNewDepartment"
                    : "feedback.config.departmentDetail"
                )
              }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="">{{ $t("feedback.config.departmentCode") }}</label>
              <input
                type="text"
                class="form-control"
                v-model="departmentData.departmentCode"
              />
            </div>
            <div class="form-group">
              <label for="">{{ $t("feedback.config.departmentName") }}</label>
              <input
                type="text"
                class="form-control"
                v-model="departmentData.departmentName"
              />
            </div>
            <div class="form-group">
              <label for="">{{ $t("feedback.config.departmentEmail") }}</label>
              <input
                type="text"
                class="form-control"
                v-model="departmentData.departmentEmail"
              />
            </div>
            <div class="form-group">
              <label for="">{{
                $t("feedback.config.departmentManager")
              }}</label>
              <v-select
                class="clear"
                :options="staffList"
                :reduce="data => data.value"
                :getOptionLabel="option => option.full_name"
                v-model="departmentData.departmentManager"
                :placeholder="$t('customer.fullname')"
              >
                <template #list-header>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">{{ $t("customer.fullname") }}</th>
                        <th scope="col">{{ $t("customer.email") }}</th>
                      </tr>
                    </thead>
                  </table>
                </template>
                <template v-slot:option="option">
                  <div
                    style="display: flex; padding-top: 5px; padding-bottom: 5px; border-bottom: 1px solid #ccc"
                  >
                    <div style="width: 50%; word-break: break-all;">
                      {{ option.full_name }}
                    </div>
                    <div style="width: 50%">
                      {{ option.email }}
                    </div>
                  </div>
                </template>
              </v-select>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button type="button" class="btn btn-primary" @click="onSave">
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <!-- Modal modal-user-in-department-list -->
    <div
      class="modal fade"
      :ref="`modal-user-in-department-list`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("feedback.config.userInDepartmentList") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <lte-button
                  style="float:right"
                  type="btn btn-primary"
                  v-if="
                    GET_ACCOUNT_DATA.group_id == 1 || has_perm('create_case')
                  "
                  right_icon="fa fa-plus"
                  @click="addUserInDepartment($event)"
                  >{{ $t("invoice.addnew") }}</lte-button
                >
              </div>
              <div class="col-md-12" style="margin-top: 10px">
                <b-table
                  outlined
                  :items="userInDepartmentList"
                  :fields="userInDepartmentFields"
                >
                  <template #head()="scope">
                    <div class="">{{ $t(scope.label) }}</div>
                  </template>
                  <template #cell(actions)="row">
                    <div class="btn-group">
                      <button
                        type="button"
                        class="btn btn-danger dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="true"
                      >
                        <i class="fa fa-fw fa-ellipsis-h"></i>
                      </button>
                      <ul class="dropdown-menu" style="min-width: 50px;">
                        <li style="margin-top: 5px">
                          <button
                            v-if="
                              GET_ACCOUNT_DATA.group_id == 1 ||
                                has_perm('delete_case')
                            "
                            class="btn btn-danger btn-sm"
                            style="margin-left: 6px;"
                            @click="onDeleteDepartment(row)"
                          >
                            <i class="glyphicon glyphicon-trash"></i>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-right"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <!-- Modal modal-add-user-in-department -->
    <div
      class="modal fade"
      :ref="`modal-add-user-in-department`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("feedback.config.userInDepartmentList") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12" style="margin-top: 10px">
                <div class="form-group">
                  <v-select
                    class="clear"
                    :options="staffList"
                    :reduce="data => data.value"
                    :getOptionLabel="option => option.full_name"
                    v-model="staffSelect"
                    :placeholder="$t('customer.fullname')"
                  >
                    <template #list-header>
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">{{ $t("customer.fullname") }}</th>
                            <th scope="col">{{ $t("customer.email") }}</th>
                          </tr>
                        </thead>
                      </table>
                    </template>
                    <template v-slot:option="option">
                      <div
                        style="display: flex; padding-top: 5px; padding-bottom: 5px; border-bottom: 1px solid #ccc"
                      >
                        <div style="width: 50%; word-break: break-all;">
                          {{ option.full_name }}
                        </div>
                        <div style="width: 50%">
                          {{ option.email }}
                        </div>
                      </div>
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onAddUserInDepartment"
            >
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
  </div>
</template>
<script>
import CustomPaginator from "@/components/CustomPaginator.vue";
import LTEButton from "@/components/LTEButton.vue";
import LTEModal from "@/components/LTEModal.vue";
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
export default {
  components: {
    "lte-button": LTEButton,
    "lte-modal": LTEModal,
    CustomPaginator
  },
  data: () => ({
    DepartmentFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "departmentCode",
        label: "feedback.config.departmentCode"
      },
      {
        key: "departmentName",
        label: "feedback.config.departmentName"
      },
      {
        key: "departmentEmail",
        label: "feedback.config.departmentEmail"
      },
      {
        key: "departmentManagerName",
        label: "feedback.config.departmentManager"
      },
      { key: "actions", label: "common.action" }
    ],
    departmentItems: [],
    departmentData: {
      id: 0,
      departmentCode: null,
      departmentName: null,
      departmentEmail: null,
      departmentManager: null
    },
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    userInDepartmentList: [],
    userInDepartmentFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "fullName",
        label: "customer.fullname"
      },
      {
        key: "email",
        label: "customer.email"
      },
      { key: "actions", label: "common.action" }
    ],
    staffList: [],
    staffSelect: null,
    // staffExcludeDepartmentList: [],
    isModalVisible: false,
    objModal: [
      {
        title: "common.delete_modal.title",
        body: "common.delete_modal.content",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    originalRecordData: []
  }),
  watch: {
    GET_DEPARTMENT_LIST_DATA: function() {
      let data = this.GET_DEPARTMENT_LIST_DATA.results;
      let paginate = this.GET_DEPARTMENT_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.departmentItems = [];
      data.forEach((value, i) => {
        let nonumber =
          i +
          1 +
          (this.paginateData.currentPage - 1) * this.paginateData.pageSize;
        let item = {
          id: value.id,
          nonumber: nonumber,
          departmentName: value.name,
          departmentCode: value.code,
          departmentEmail: value.email,
          departmentManagerId: value.manager,
          departmentManagerName: value.manager_data.full_name
        };
        this.departmentItems.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_DEPARTMENT_LIST_DATA"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    addNew: function(event) {
      event.preventDefault();
      $(this.$refs[`modal-department`]).modal("show");
      this.departmentData = {
        id: 0,
        departmentName: null,
        departmentCode: null,
        departmentEmail: null,
        departmentManager: null
      };
      this.getStaffList()
    },
    onShowDetail: function(data) {
      $(this.$refs[`modal-department`]).modal("show");
      this.departmentData.id = data.id;
      this.departmentData.departmentName = data.departmentName;
      this.departmentData.departmentCode = data.departmentCode;
      this.departmentData.departmentEmail = data.departmentEmail;
      this.departmentData.departmentManager = data.departmentManagerId
    },
    onDeleteDepartment: function(row) {
      this.originalRecordData = row.item
      this.isModalVisible = true
    },
    getDepartmentList: function(page) {
      let filter = {
        params: {
          page: page
        }
      };
      this.GET_DEPARTMENT_LIST(filter);
    },
    onSave: function() {
      if (utils.isEmptyString(this.departmentData.departmentName)) {
        this.ON_SHOW_TOAST({
          message: this.$t("feedback.config.departmentName"),
          styleType: "danger"
        });
      } else {
        let data = {
          id: this.departmentData.id,
          name: this.departmentData.departmentName,
          code: this.departmentData.departmentCode,
          email: this.departmentData.departmentEmail,
          manager: this.departmentData.departmentManager
        };
        if (this.departmentData.id === 0) {
          this.CREATE_DEPARTMENT(data).then(
            function() {
              $(this.$refs[`modal-department`]).modal("hide");
              this.getDepartmentList(this.paginateData.currentPage);
              this.SUCCESS_TOAST();
            }.bind(this)
          ).catch(
            function(error) {
              this.isLoading = false;
              this.showError(error.response.data.message);
            }.bind(this)
          );
        } else {
          this.UPDATE_DEPARTMENT(data).then(
            function() {
              $(this.$refs[`modal-department`]).modal("hide");
              this.getDepartmentList(this.paginateData.currentPage);
              this.SUCCESS_TOAST();
            }.bind(this)
          ).catch(
            function(error) {
              this.isLoading = false;
              this.showError(error.response.data.message);
            }.bind(this)
          );
        }
      }
    },
    onCustomPagination: function(data) {
      this.paginateData.currentPage = data;
      this.getDepartmentList(data);
    },
    onRefreshData: function() {
      this.getDepartmentList(1);
    },
    onShowUserInDepartment: function(data) {
      $(this.$refs[`modal-user-in-department-list`]).modal("show");
      this.departmentData.id = data.id;
      this.getUserInDepartmentList();
      this.getStaffList(true)
    },
    getUserInDepartmentList: function() {
      // this.staffExcludeDepartmentList = this.staffList;
      let filter = {
        params: {
          departmentId: this.departmentData.id
        }
      };
      this.GET_USER_IN_DEPARTMENT(filter).then(
        function(res) {
          this.userInDepartmentList = [];
          let data = res;
          data.forEach((value, index) => {
            let item = {
              nonumber: index + 1,
              value: value.id,
              fullName: value.last_name + " " + value.first_name,
              email: value.email
            };
            this.userInDepartmentList.push(item);
            // get user not in department
            // this.staffExcludeDepartmentList = this.staffExcludeDepartmentList.filter(
            //   x => x.value !== value.id
            // );
          });
        }.bind(this)
      );
    },
    addUserInDepartment: function(event) {
      event.preventDefault();
      $(this.$refs[`modal-add-user-in-department`]).modal("show");
      this.staffSelect = null;
    },
    onAddUserInDepartment: function() {
      if (utils.isEmptyString(this.staffSelect)) {
        this.ON_SHOW_TOAST({
          message: this.$t("customer.fullname"),
          styleType: "danger"
        });
      } else {
        let data = {
          userId: this.staffSelect,
          departmentId: this.departmentData.id
        };
        this.ADD_USER_IN_DEPARTMENT(data)
          .then(
            function() {
              $(this.$refs[`modal-department`]).modal("hide");
              this.getUserInDepartmentList();
              $(this.$refs[`modal-add-user-in-department`]).modal("hide");
              this.getStaffList(true)
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.isLoading = false;
              this.ON_SHOW_TOAST();
            }.bind(this)
          );
      }
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onConfirm: function() {
      this.isModalVisible = false;
      const payload = {
        id: this.originalRecordData.id
      };
      this.DELETE_DEPARTMENT(payload)
        .then(
          function() {
            this.getDepartmentList(this.paginateData.currentPage);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    getStaffList: function(excludeUserInDepartment) {
      let filter = {
        params: {
          excludeUserInDepartment: excludeUserInDepartment
        }
      };
      this.GET_STAFF_LIST(filter).then(
        function(res) {
          let staffList = res.data;
          let staffs = [];
          staffList.forEach(data => {
            let full_name = `${data.last_name} ${data.first_name}`;
            let item = {
              value: data.id,
              full_name: full_name,
              email: data.email
            };
            staffs.push(item);
          });
          this.staffList = staffs;
        }.bind(this)
      );
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "GET_DEPARTMENT_LIST",
      "CREATE_DEPARTMENT",
      "UPDATE_DEPARTMENT",
      "DELETE_DEPARTMENT",
      "GET_USER_IN_DEPARTMENT",
      "ADD_USER_IN_DEPARTMENT",
      "GET_STAFF_LIST"
    ])
  },
  mounted() {
    this.getDepartmentList(1);
    this.getStaffList()
  }
};
</script>
<style scoped>
/* .modal {
  text-align: center;
}

.modal:before {
  display: inline-block;
  vertical-align: middle;
  content: " ";
  height: 100%;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
} */
</style>



// WEBPACK FOOTER //
// src/views/Case/DepartmentList.vue